import axios from '../../axios';
import { toast } from 'react-toastify';
import {
   GET_ITEM,
   GET_ITEM_FOR_MASTER,
   UPDATE_ITEM,
   ADD_ITEM,
   GET_ITEM_GROUP,
   DELETE_ITEM,
   GET_ITEM_BY_FINISH_ITEM,
   GET_ONE_ITEM,
   GET_ITEMS,
   IMPORT_ITEM_EXCEL,
   GET_ITEM_FOR_STOCK,
} from '../types';

export const getItemForMaster = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/item/all', { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_ITEM_FOR_MASTER,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
         return res.data.data;
      }
   } catch (err) {
      console.error('Failed to add item. Please try again.');
   }
};

export const getItemForStock = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/item/all', { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_ITEM_FOR_STOCK,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
         return res.data.data;
      }
   } catch (err) {
      console.error('Failed to add item. Please try again.');
   }
};

export const getItem = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/item/all', { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_ITEM,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
      }
   } catch (err) {
      console.error('Failed to add item. Please try again.');
   }
};

export const getItems = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/item/all', { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_ITEMS,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });

         return res.data.data;
      }
   } catch (err) {
      console.error('Failed to add item. Please try again.');
   }
};

export const getItemGroup = () => async (dispatch) => {
   try {
      const res = await axios.get('/item-group/all');

      if (res.data.code === 1) {
         dispatch({ type: GET_ITEM_GROUP, payload: res.data.data });
      }
   } catch (err) {
      console.error('Failed to add item. Please try again.');
   }
};

export const addItem = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/item/add', formData, {
         headers: {
            'Content-Type': 'multipart/form-data',
         },
      });

      if (res.data.code === 1) {
         dispatch({ type: ADD_ITEM, payload: res.data.data });
         setTimeout(() => {
            toast.success('Item added successfully!');
         }, 1000);
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.error(res.data.message);
         }, 1000);
         return res.data;
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
      return { code: 0, message: 'API request failed' };
   }
};

export const updateItem = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/item/update', formData, {
         headers: {
            'Content-Type': 'multipart/form-data',
         },
      });

      if (res.data.code === 1) {
         dispatch({ type: UPDATE_ITEM, payload: res.data.data });

         setTimeout(() => {
            toast.success('Item updated successfully!');
         }, 1000);
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.error(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
      // toast.error('Failed to update item. Please try again.');
   }
};

// Delete Item
export const deleteItem = (id, companyId) => async (dispatch) => {
   try {
      if (!id) {
         toast.error('Please select any record');
         return false;
      }
      const res = await axios.post(`/item/delete/${id}/${companyId}`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_ITEM, payload: { id } });
         toast.success('Item deleted successfully!');
      }
   } catch (err) {
      if (err.response.status === 400) {
         toast.error(err.response.data.message);
         return;
      }
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
      // toast.error('Failed to delete Item. Please try again.');
   }
};

export const getItemByFinishItem = () => async (dispatch) => {
   try {
      const res = await axios.get('/item/finish');
      if (res.data.code === 1) {
         dispatch({ type: GET_ITEM_BY_FINISH_ITEM, payload: res.data.data });
      }
   } catch (err) {
      console.error('Failed to get item by finish item. Please try again.');
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const getSingleItem = (id) => async (dispatch) => {
   try {
      const res = await axios.get(`/item/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: GET_ONE_ITEM, payload: res.data.data });
         return res.data.data;
      }
      return res.data.data;
   } catch (err) {
      console.error('Failed to get item by finish item. Please try again.');
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const importItemExcel = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/item/importItems',
         formData,
         {
            headers: {
               'Content-Type': 'multipart/form-data',
            },
         }
      );

      if (res.data.code === 1) {
         dispatch({ type: IMPORT_ITEM_EXCEL, payload: res.data.data });
         setTimeout(() => {
            toast.success(`
               Total Items: ${res.data.data?.totalProcessed || 0},   
               Successfully Added Items: ${res.data.data?.totalImported || 0},   
               Failed Items: ${res.data.data?.totalSkipped || 0}
            `);
         }, 0);
         return res.data.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.error(res.data.message);
         }, 1000);
         return res.data;
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
      return { code: 0, message: 'API request failed' };
   }
};
